import { formatDate } from '@btime/helpers'
import { compose, path } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import FlexGrid from '../../../components/structure/FlexGrid'
import Text, { SmallText } from '../../../packages/kiti/components/presentation/Text'
import Avatar from '../../../components/presentation/Avatar'
import { useStockItem } from './_load/StockItemLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsMenu from '../../../packages/kiti/components/tabs/TabsMenu'

const ModalHeader = () => {
  const { t } = useTranslation()
  const stockItem = useStockItem()
  const insertedAt = compose(formatDate('DD/MM/YYYY HH:mm'), path(['insertedAt']))(stockItem)
  const updatedAt = compose(formatDate('DD/MM/YYYY HH:mm'), path(['updatedAt']))(stockItem)

  return (
    <>
      <Grid justify="flex-start" align="center" gutter={0.3}>
        <Col flex={1}>
          <FlexGrid justify="flex-start" gutter={0.3}>
            <Text color="dark1" bold>
              {stockItem?.name}
            </Text>
          </FlexGrid>
          <SmallText color="dark3">
            {t('createdAt')} {insertedAt}
          </SmallText>
          <SmallText color="dark3">
            {t('updatedAt')} {updatedAt}
          </SmallText>
        </Col>
        <Col flex={1}></Col>
      </Grid>

      <Separator weight={6} />

      <TabsMenu t={t} />
    </>
  )
}

export default ModalHeader
